<template>
  <div>
    <div class="w-full p-4 border-l bg-gray-100 border-gray-200 text-gray-700">
      <details v-if="paymentMethod.isSaved.value" class="border rounded">
        <summary
          v-text="i18n.payment_method.label_saved"
          class="p-2 cursor-pointer"
        />
        <div
          v-if="paymentMethod.savedCard.value"
          class="flex px-2 justify-between items-center text-black"
        >
          <span
            >{{ paymentMethod.savedCard.value.brand.toUpperCase() }} **** ****
            **** {{ paymentMethod.savedCard.value.last4 }}</span
          >
          <span
            >{{ paymentMethod.savedCard.value.exp_month }}/{{
              paymentMethod.savedCard.value.exp_year
            }}</span
          >
        </div>
        <div class="flex justify-end p-1">
          <ranch-button
            action="warning border border-red-300"
            icon="trash-alt"
            :label="i18n.payment_method.delete"
            @click="paymentMethod.delete"
          />
        </div>
      </details>
      <new-refill-amount-selection v-if="!$route.query.coupon" />
      <details class="border rounded" :open="!!$route.query.coupon">
        <summary
          v-text="i18n.redeem_voucher.label_redeem"
          class="p-2 cursor-pointer"
        />
        <form class="px-5" @submit.prevent="redeemVoucher.redeem">
          <label class="text-black"
            >{{ i18n.redeem_voucher.explanation }}
            <input
              type="text"
              v-model="redeemVoucher.voucher.value"
              required
              :class="{ danger: redeemVoucher.errors.value.length }"
            />
          </label>
          <p
            class="text-red-700 font-bold"
            v-for="err in redeemVoucher.errors.value"
            :key="err"
            v-html="err"
          />
          <p
            class="text-green-700 font-bold"
            v-if="redeemVoucher.success.value"
          >
            {{ redeemVoucher.success.value }}
          </p>
          <div class="flex justify-center pb-2">
            <ranch-button
              icon="ticket-alt"
              :label="i18n.redeem_voucher.button_redeem"
            />
          </div>
        </form>
      </details>
      <new-refill-amount-selection v-if="!!$route.query.coupon" />
    </div>
  </div>
</template>

<script>
import NewRefillAmountSelection from "./NewRefill/AmountSelection";

import paymentMethod from "@/composition/paymentMethod";

export default {
  props: ["i18n"],

  components: {
    NewRefillAmountSelection,
  },
  setup(props, context) {
    const route = context.root.$route;
    return {
      redeemVoucher: setupVoucher(route.query.coupon || ""),
      paymentMethod: paymentMethod(),
    };
  },
};

import { ref } from "@vue/composition-api";
import { useStore } from "@/store/composition";
import axios from "axios";
import { handleAxiosError } from "@/boot/functions";

function setupVoucher(initialValue) {
  const voucher = ref(initialValue);
  const errors = ref([]);
  const success = ref("");
  const store = useStore();
  const redeem = () => {
    errors.value = [];
    success.value = "";
    axios
      .post("/api/app/billing/coupon/redeem", { code: voucher.value })
      .then((resp) => {
        success.value = resp.data.message;
        store.dispatch("safe/getPaginator");
      })
      .catch((err) => {
        if (
          !err.response ||
          !err.response.data ||
          !err.response.data.errors ||
          !err.response.data.errors.code
        ) {
          throw err;
        }
        errors.value = err.response.data.errors.code;
      })
      .catch(handleAxiosError);
  };
  if (initialValue) {
    redeem();
  }
  return {
    voucher,
    redeem,
    errors,
    success,
  };
}
</script>
